import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ACSApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ProjectOverviewDto } from '../../../commonTypes/acs';
import { setCachedProjectSummaryOverview, selectCachedProjectSummaryOverview } from '../../../store/slices/projects.slice';

const useHttpGetProjectSummaryOverview = (projectId: string, month: string, year: number) => {
    const acsApi: ACSApi = useContainer(ACSApi);
    const dispatch = useDispatch();
    const cacheKey = `${projectId}-${month}-${year}`;
    const cachedData = useSelector(selectCachedProjectSummaryOverview(cacheKey));
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<ProjectOverviewDto[]>([]);

    useEffect(() => {
        if (!projectId || !month || !year) {
            setIsReady(true);
            setData([]);
            return;
        }

        if (cachedData) {
            setData(cachedData);
            setIsReady(true);
            return;
        }

        setIsReady(false);
        const { exec, abort } = acsApi.getProjectSummaryOverview({
            params: { projectId },
            query: { month, year },
            onSuccess: res => {
                dispatch(setCachedProjectSummaryOverview({ key: cacheKey, data: res.body }));
                setData(res.body);
            },
            onError: error => console.error('Error fetching project summary overview:', error),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, [projectId, month, year, cachedData, cacheKey, dispatch]);

    return { isReady, data };
};

export default useHttpGetProjectSummaryOverview;
